import { SelectorEntities } from 'shared/entities/components/Selector';
import { TFunctionType } from 'shared/entities/localization';

import { VarType } from '../vars';
import { FileType } from '../file';

import { MapParseDateFilterToFormat } from './client';

export enum ParseMessageFilterType {
  number = 'number',
  word = 'word',
  string = 'string',
  phone = 'phone',
  email = 'email',
  regex = 'regex',
  date = 'date',
  time = 'time',
  datetime = 'datetime'
}

export type ParseMessageDateFilterType =
  | ParseMessageFilterType.date
  | ParseMessageFilterType.datetime
  | ParseMessageFilterType.time;

export const mapParseMessageFilterTypeToVarType: Record<
  ParseMessageFilterType,
  VarType
> = {
  [ParseMessageFilterType.number]: VarType.num,
  [ParseMessageFilterType.string]: VarType.str,
  [ParseMessageFilterType.word]: VarType.str,
  [ParseMessageFilterType.phone]: VarType.str,
  [ParseMessageFilterType.email]: VarType.str,
  [ParseMessageFilterType.regex]: VarType.str,
  [ParseMessageFilterType.date]: VarType.date,
  [ParseMessageFilterType.datetime]: VarType.datetime,
  [ParseMessageFilterType.time]: VarType.datetime
};

// десятичный разделитель
export enum ParseMessageNumberFilterDecimalSep {
  // запятая/точка
  both = 'both',
  // только точка
  dot = 'dot',
  // только запятая
  comma = 'comma'
}

export const PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE =
  '<SAVE_ALL_MESSAGE_TO_STRING_OR_NUM_VARIABLE>';

export const PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE_WORD = `^${PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE}$`;

export type ParseMessageNumberFilterServer = {
  kind: ParseMessageFilterType.number;
  min: number | null;
  max: number | null;
  decimal_sep: ParseMessageNumberFilterDecimalSep;
  // только целые числа
  integer: boolean;
};

export type ParseMessageStringFilterKind =
  | ParseMessageFilterType.word
  | ParseMessageFilterType.string
  | ParseMessageFilterType.phone
  | ParseMessageFilterType.email;

export type ParseMessageStringFilterServer = {
  kind: ParseMessageStringFilterKind;
  min: number | null;
  max: number | null;
};

export type ParseMessageRegExFilterServer = {
  kind: ParseMessageFilterType.regex;
  regex: string;
};

export type ParseMessageDateFilterServer<K extends ParseMessageDateFilterType> =
  {
    kind: K;
    format: MapParseDateFilterToFormat[K];
  };

export type ParseMessageGroupServer = {
  filter:
    | ParseMessageNumberFilterServer
    | ParseMessageStringFilterServer
    | ParseMessageRegExFilterServer
    | ParseMessageDateFilterServer<ParseMessageFilterType.date>
    | ParseMessageDateFilterServer<ParseMessageFilterType.datetime>
    | ParseMessageDateFilterServer<ParseMessageFilterType.time>;
  target: string | null;
};

export type ParseTextBaseServer = {
  expr: string;
  groups: Record<string, ParseMessageGroupServer>;
};

export type ParseTextServer = ParseTextBaseServer & {
  source: string;
};

export type ParseAttachmentsServer = {
  types: FileType[];
  max_size: number | null;
  // переменная типа list
  target: string;
  count?: number | null;
  min_count?: number | null;
  max_count?: number | null;
};

export const mapDecimalSepToSelectorOption: SelectorEntities<ParseMessageNumberFilterDecimalSep> =
  Object.values(ParseMessageNumberFilterDecimalSep).reduce<
    SelectorEntities<ParseMessageNumberFilterDecimalSep>
  >(
    (acc, item) => ({
      ...acc,
      [item]: {
        id: item,
        title: (t: TFunctionType) =>
          t(`parsing.parseMessageNumberFilterDecimalSep.${item}`, {
            ns: 'entities'
          })
      }
    }),
    {} as SelectorEntities<ParseMessageNumberFilterDecimalSep>
  );

export const orderDecimalSepSelectorOptions = [
  ParseMessageNumberFilterDecimalSep.both,
  ParseMessageNumberFilterDecimalSep.dot,
  ParseMessageNumberFilterDecimalSep.comma
];

export const mapFilterTypeToSelectorOption: SelectorEntities<ParseMessageFilterType> =
  Object.values(ParseMessageFilterType).reduce<
    SelectorEntities<ParseMessageFilterType>
  >(
    (acc, item) => ({
      ...acc,
      [item]: {
        id: item,
        title: (t: TFunctionType) =>
          t(`parsing.parseMessageFilterType.${item}`, {
            ns: 'entities'
          })
      }
    }),
    {} as SelectorEntities<ParseMessageFilterType>
  );

export const orderSelectorOptions = [
  ParseMessageFilterType.email,
  ParseMessageFilterType.phone,
  ParseMessageFilterType.string,
  ParseMessageFilterType.number,
  ParseMessageFilterType.word,
  ParseMessageFilterType.regex,
  ParseMessageFilterType.date,
  ParseMessageFilterType.time,
  ParseMessageFilterType.datetime
];

export enum ParseMessageDateFilterFormat {
  dayMonthYear = '%d.%m.%Y',
  dayMonthYearWithSlash = '%d/%m/%Y',
  dateWithSlash = '%m/%d/%Y'
}

export enum ParseMessageDateTimeFilterFormat {
  dayMonthYearWithTime = '%d.%m.%Y %H:%M',
  dayMonthYearTimeWithSlash = '%d/%m/%Y %H:%M',
  dateTimeWithSlash = '%m/%d/%Y %H:%M'
}

export enum ParseMessageTimeFilterFormat {
  time = '%H:%M',
  timeWithSec = '%H:%M:%S'
}
